import { render, staticRenderFns } from "./BlockParagraph.vue?vue&type=template&id=19cca542&"
import script from "./BlockParagraph.vue?vue&type=script&lang=js&"
export * from "./BlockParagraph.vue?vue&type=script&lang=js&"
import style0 from "./BlockParagraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports